import { render, staticRenderFns } from "./DomainWebpageList.vue?vue&type=template&id=3cfc95e2&scoped=true&"
import script from "./DomainWebpageList.vue?vue&type=script&lang=js&"
export * from "./DomainWebpageList.vue?vue&type=script&lang=js&"
import style0 from "./DomainWebpageList.vue?vue&type=style&index=0&id=3cfc95e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfc95e2",
  null
  
)

export default component.exports